<script setup lang="ts">
import {onBeforeUnmount, onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import type {Profile} from '~/repository/types';

const {t} = useI18n();

const props = defineProps<{ profile: Profile, postsNumber: Number }>();
const emit = defineEmits<{
  (event: 'subscribe'): void;
}>();

const isScrolled = ref(false);

function handleScroll() {
  isScrolled.value = window.scrollY > 260;
}

function handleSubscribeClick() {
  emit('subscribe');
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>

<template>
  <div :class="{ 'slide-up': isScrolled, 'hidden-section': !isScrolled }"
       class="fixed flex gap-2 w-[95%] items-center rounded-xl border-[0.5px] border-gray-400 left-0 md:left-1/2 md:-translate-x-1/2 max-md:right-0 px-3 py-2 md:py-4 md:px-4 z-50 bottom-[55px] md:bottom-4 mx-auto max-w-lg md:rounded-xl bg-background md:border-[0.5px] md:border-gray-400 md:shadow-2xl transition-transform will-change-transform transform-gpu duration-500">
    <UserAvatar :user="profile"/>
    <div class="grow shrink-0">
      <div class="font-semibold">{{ profile?.username }}</div>
      <div class="text-gray text-xs">{{ t('subscription.unlock_access', {count: postsNumber}) }}</div>
    </div>
    <Button class="ml-auto text-white bg-gradient !w-fit" @click="handleSubscribeClick">
      {{ t('subscription.subscribe') }}
    </Button>
  </div>
</template>

<style scoped>
.hidden-section {
  transform: translate(0, 100px);
  @media (min-width: 768px) {
    transform: translate(-50%, 100px);
  }
}

.slide-up {
  transform: translate(0, 0);
  @media (min-width: 768px) {
    transform: translate(-50%, 0);
  }
}
</style>
